/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';
import { Paper } from '@mui/material';

export const AlertModalWrapper = styled(Paper)`
  display: flex;
  flex-direction: column;
  width: 470px;
  max-width: calc(100% - 20px);
  padding: 40px 30px 46px;
`;
